import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AppContext } from './App';
import './Navbar.css';
import Cookies from 'js-cookie';

const Navbar = () => {
  const { user, setUser, isLogged, setIsLogged } = useContext(AppContext);
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = () => {
    setUser(null); // Clear user data
    setIsLogged(false); // Update the login state
    Cookies.remove('user');
    Cookies.remove('isLogged');
    navigate('/'); // Redirect to the homepage or login page
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <button className="menu-button" onClick={toggleMenu}>
        ☰
      </button>
      <ul className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
        {isLogged ? (
          <>
            <li><Link to="/personal_info" onClick={toggleMenu}>אזור אישי</Link></li>
            <li><Link to="/expenses" onClick={toggleMenu}>ניהול הוצאות</Link></li>
            <li><Link to="/tables" onClick={toggleMenu}>סידור שולחנות</Link></li>
            <li><Link to="/add-invites" onClick={toggleMenu}>הוספת מוזמנים</Link></li>
            <li><Link to="/my-invites" onClick={toggleMenu}>המוזמנים שלי</Link></li>
            <li>
              שלום {user ? user.user.username : 'משתמש'} / 
              <Link to="/" onClick={() => { toggleMenu(); handleLogout(); }}>התנתק</Link>
            </li>
          </>
        ) : (
          <>
             <li><Link to="/" onClick={toggleMenu}>דף הבית</Link></li>
             <li><Link to="/suggests" onClick={toggleMenu}>החבילות שלנו</Link></li>
             <li><Link to="/login" onClick={toggleMenu}>אזור אישי</Link></li>
            <li><Link to="/contact" onClick={toggleMenu}>צור קשר</Link></li>
          </>
        )}
      </ul>
    </nav>
  );
};

export default Navbar;
